import { useState } from 'react'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: 'rgba(0, 0, 0, 0.95)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid var(--border)'
    }}>
      <div className="container">
        <div className="flex flex-between" style={{ padding: 'var(--spacing-md) 0' }}>
          {/* Logo */}
          <div className="flex flex-center">
            <img
              src="/icons/logo.png"
              alt="AscensosApp Vortex"
              style={{
                height: '40px',
                filter: 'brightness(1) invert(0)'
              }}
            />
            <span style={{
              marginLeft: 'var(--spacing-md)',
              fontSize: '1.25rem',
              fontWeight: '700',
              color: 'var(--text-primary)'
            }}>
              Vortex Software
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="flex gap-lg" style={{ display: 'none' }}>
            <a href="#about" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Sobre</a>
            <a href="#features" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Características</a>
            <a href="#howitworks" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Cómo funciona</a>
            <a href="#testimonials" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Testimonios</a>
            <a href="#screenshots" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Galería</a>
            <a href="#availability" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Descarga</a>
            <a href="#contact" style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>  Contacto</a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-primary)',
              fontSize: '1.5rem',
              cursor: 'pointer',
              display: 'block'
            }}
          >
            ☰
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav style={{
            background: 'var(--bg-secondary)',
            borderTop: '1px solid var(--border)',
            padding: 'var(--spacing-md) 0'
          }}>
            <div className="flex flex-wrap gap-md" style={{ flexDirection: 'column' }}>
              <a href="#about" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  ¿Que es Vortex?</a>
              <a href="#features" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Características</a>
              <a href="#howitworks" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Cómo funciona</a>
              <a href="#testimonials" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Testimonios</a>
              <a href="#screenshots" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Galería</a>
              <a href="#availability" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Descarga</a>
              <a href="#contact" style={{ color: 'var(--text-secondary)', fontWeight: '500', padding: 'var(--spacing-sm) 0' }}>  Contacto</a>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
} 